import { MoneyBox } from '@apply/components';
import { formatCurrencyOrUndefined } from '@apply/ui';
import { IBudgetFixFlip } from '@apply/api/src/api/ApplyApi';
import { ApplicationQuestionReviewItem } from '../../../../components/ApplicationQuestionReviewItem';
import { useBudgetFixFlipField } from '../../../../../queries/useBudgetFixFlipField';

interface LightingProps {
    required?: boolean;
    propertyGuid: string;
    isReview?: boolean;
}

export const Lighting: React.FC<LightingProps> = ({ required = false, propertyGuid, isReview = false }) => {
    const [lighting, set_lighting] = useBudgetFixFlipField<number>(
        propertyGuid,
        (b) => (b.values?.['Interior']?.['Lighting']?.[1] as number) ?? 0,
        (b, v) => ({ ...b, values: { ...b.values, 'Interior': { ...b.values?.['Interior'], 'Lighting': [b.values?.['Interior']?.['Lighting']?.[0] ?? '', v] as [string, number] } } })
    );
    const label = 'Lighting';
    return (
        <>
            {isReview ? (
                <ApplicationQuestionReviewItem
                    label={label}
                    value={formatCurrencyOrUndefined(lighting)}
                />
            ) : (
                <MoneyBox
                    id={'lighting'}
                    allowNegative={false}
                    value={lighting}
                    onChange={(value) => set_lighting(value)}
                    required={required}
                    label={label}
                />
            )}
        </>
    );
};
